// 輪盤玩家資訊 抽獎券、轉盤次數

const CampaignSpinInfo = ({ ticketsAmount, leftSpinTimes }) => {
    return (
        <div
            className="absolute w-full left-0 top-[10px] z-[5] between-center [&>p]:border-1 [&>p]:border-[#fff] [&>p]:border-opacity-[.3] [&>p]:text-[#fff]
            [&>p]:text-btn2 [&>p]:text-center [&>p]:px-[20px] [&>p]:py-[6px] [&>p]:rounded-[6px] [&>p]:backdrop-blur-[5px]
            [&>p]:flex [&>p]:flex-col [&>p]:gap-y-[3px] usx:w-[calc(100%+20px)] usx:left-[50%] usx:translate-x-[-50%]"
        >
            {/* 抽獎券數 */}
            <p className="bg-[#599496] bg-opacity-[.26]">
                <span>抽獎券</span>
                <span>{ticketsAmount || 0}</span>
            </p>

            {/* 剩餘轉盤次數 */}
            <p className="bg-[#000] bg-opacity-[.5] uxs:!px-[15px]">
                <span>剩餘次數</span>
                <span>{leftSpinTimes || 0}</span>
            </p>
        </div>
    );
};

export default CampaignSpinInfo;
